/**
 * „Primii pași”: lista de pe panou pentru o firmă nouă. Pașii se bifează
 * singuri, din ce există deja în cont; nu se ține nimic în plus în bază, în
 * afară de „Ascunde lista”.
 */

/** Ce are firma acum, numărat de server. */
export interface OnboardingFacts {
  /** CUI și adresa sediului completate: fără ele, comanda iese fără datele firmei */
  companyData: boolean;
  sites: number;
  /** furnizori nearhivați */
  suppliers: number;
  rfqs: number;
  /** colegi activi în afară de tine, plus invitațiile încă bune */
  colleagues: number;
  /**
   * Firma a lucrat deja: o cerere de orice fel (și comanda rapidă face una) sau un necesar din șantier.
   * Până atunci panoul arată doar „Primii pași”, nu zece cartonașe cu zero (2026-11-03).
   */
  started: boolean;
}

export type OnboardingStepId = 'company' | 'site' | 'suppliers' | 'rfq' | 'team';

export interface OnboardingStep {
  id: OnboardingStepId;
  done: boolean;
}

/** Destui cât să ai ce compara: o cerere are rost de la trei oferte. */
export const ONBOARDING_SUPPLIERS = 3;

/**
 * Ordinea (schimbată pe 2026-11-03): întâi ce duce la prima comparație (locul, furnizorii, cererea),
 * fiindcă acolo vede omul rostul aplicației; datele firmei abia trebuie la prima comandă.
 */
export function onboardingSteps(f: OnboardingFacts): OnboardingStep[] {
  return [
    { id: 'site', done: f.sites > 0 },
    { id: 'suppliers', done: f.suppliers >= ONBOARDING_SUPPLIERS },
    { id: 'rfq', done: f.rfqs > 0 },
    { id: 'company', done: f.companyData },
    { id: 'team', done: f.colleagues > 0 },
  ];
}
